import request from '@/utils/request'


// 查询商品规格信息列表
export function listSku(query) {
  return request({
    url: '/goods/sku/list',
    method: 'get',
    params: query
  })
}

// 查询商品规格信息分页
export function pageSku(query) {
  return request({
    url: '/goods/sku/page',
    method: 'get',
    params: query
  })
}

// 查询商品规格信息详细
export function getSku(data) {
  return request({
    url: '/goods/sku/detail',
    method: 'get',
    params: data
  })
}

export function batchAdd(data) {
  return request({
    url: '/goods/sku/batchAdd',
    method: 'post',
    data: data
  })
}
// 新增商品规格信息
export function addSku(data) {
  return request({
    url: '/goods/sku/add',
    method: 'post',
    data: data
  })
}

// 修改商品规格信息
export function updateSku(data) {
  return request({
    url: '/goods/sku/edit',
    method: 'post',
    data: data
  })
}

// 删除商品规格信息
export function delSku(data) {
  return request({
    url: '/goods/sku/delete',
    method: 'post',
    data: data
  })
}

export function pushWDT(data) {
  return request({
    url: '/goods/sku/pushWDT',
    method: 'post',
    data: data
  })
}
